import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CookieConsentProvider } from "./hooks/useCookieConsent";
import CookieConsent from "./components/feature/CookieConsent";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <CookieConsentProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
        <CookieConsent />
      </CookieConsentProvider>
    </I18nextProvider>
  );
}

export default App;